export class RaiseDisputeOnShippingDto {
    refNo: number;
    onDateTime: string;
    serviceManID: string;
    shippingNo: string;
    reason: string;
    currentStatus: string;
    amountAsPerSuggestedRoute: number;
    additionalAmountIfAny: number;
    finalAmount: number;
}
